export default __webpack_public_path__ + "static/404-2-99500c8711c213561911b78d585a2bdc.svg";